import { TextField as MuiTextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTextField = styled(MuiTextField)(({ theme }) => ({
  fontSize: theme.fontSize.sm,
  "& .MuiFormControl-root": {
    paddingLeft: 0,
    paddingRight: 0,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRight: 0,
    borderTop: 0,
    borderLeft: 0,
    borderRadius: 0,
    borderBottom: `1px solid ${theme.palette_custom.lightBlue}`,
  },
  "& .MuiInputBase-input": {
    fontSize: theme.fontSize.sm,
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 4,
    paddingBottom: 4,
    borderBottom: `1px solid ${theme.palette_custom.lightBlue}`,
  },
  "& .MuiInputLabel-root": {
    fontSize: theme.fontSize.sm,
    transform: "none",
  },
  "& .Mui-focused": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderBottom: `2px solid ${theme.palette_custom.lightBlue}`,
    },
    color: theme.palette_custom.lightBlue,
  },
  "& .MuiInputLabel-shrink": {
    transform: "translate(0px, -9px) scale(0.75)",
  },
}));

const TextField = ({
  title,
  handleOnChange,
  value,
  error,
  helperText,
  InputLabelProps,
  onBlur,
}) => {
  return (
    <StyledTextField
      fullWidth
      label={title}
      value={value}
      error={error}
      helperText={error ? helperText : null}
      onChange={handleOnChange}
      InputLabelProps={InputLabelProps}
      onBlur={onBlur}
    />
  );
};

export default TextField;
